import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';

export const UserTimezoneStyled = styled(Box)(({ theme }) => ({
  display: 'none',
  flexDirection: 'column',
  alignItems: 'center',
  [theme.breakpoints.up('sm')]: {
    display: 'flex',
  },
}));

export const UserTimezoneTypographyStyled = styled(Typography)({
  lineHeight: 1.75,
  fontSize: 14,
});
